/**
 * @generated SignedSource<<3e836395b70b1b64529588d9d93067b7>>
 * @relayHash fd152f073d3eb402e26afca3f0a8af87
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID fd152f073d3eb402e26afca3f0a8af87

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "email"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionalManagerEmail"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "email",
        "variableName": "email"
      },
      {
        "kind": "Variable",
        "name": "regionalManagerEmail",
        "variableName": "regionalManagerEmail"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "accountUpdateRegionalManager",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountUpdateRegionalManagerMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AccountUpdateRegionalManagerMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "fd152f073d3eb402e26afca3f0a8af87",
    "metadata": {},
    "name": "AccountUpdateRegionalManagerMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "b665918fe8a2add4c290833369446eca";

export default node;
